import { useState } from 'react'
import { useNavigate } from 'react-router'
import { Flex } from '@radix-ui/themes'
import { AxiosError } from 'axios'
import { PageHeading } from '@/components/subscription/page-heading'
import { FormLabel } from '@/components/subscription/form-label'
import { Button } from '@/components/subscription/button'
import { TextLink } from '@/components/subscription/text-link'
import { createClient } from '@/api-client'
import { Account } from '@/api-client/Account'
import { styles } from './styles.css'

export const SubscriptionMypageEmail: React.FC = () => {
  const navigate = useNavigate()
  const [isSubmitting, setIsSubmitting] = useState(false)
  const [errorMessage, setErrorMessage] = useState('')

  const [email, setEmail] = useState('')
  const [password, setPassword] = useState('')

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault()

    const form = e.currentTarget
    if (!form.checkValidity()) {
      form.reportValidity()
      return
    }

    setIsSubmitting(true)
    setErrorMessage('')

    try {
      await createClient(Account).putAccount({ new_email: email, password })

      await navigate('/subscription/mypage', { state: { message: 'メールアドレスを変更しました' } })
    } catch (error) {
      setErrorMessage(error.response?.data?.error?.message_displayable || 'メールアドレスの変更に失敗しました')
    } finally {
      setIsSubmitting(false)
    }
  }

  return (
    <Flex direction="column" align="center" gap="40px" width="100%">
      <PageHeading>メールアドレス変更</PageHeading>

      <form onSubmit={handleSubmit} className={styles.form}>
        <Flex direction="column" align="center" gap="32px" width="100%">
          <Flex direction="column" gap="8px" width="100%">
            <div>
              <FormLabel htmlFor="email">新しいメールアドレス</FormLabel>
              <input
                type="email"
                id="email"
                name="email"
                className={styles.input}
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                disabled={isSubmitting}
                autoComplete="email"
                required
              />
            </div>
            <div>
              <FormLabel htmlFor="password">現在のパスワード</FormLabel>
              <input
                type="password"
                id="password"
                name="password"
                className={styles.input}
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                disabled={isSubmitting}
                autoComplete="current-password"
                required
              />
            </div>
          </Flex>
          <Flex direction="column" align="center" gap="32px" width="100%">
            <Flex direction="column" align="center" gap="16px" width="100%">
              <Button as="button" type="submit" size="m" fluid disabled={isSubmitting}>
                メールアドレスを変更する
              </Button>
              {errorMessage && <p className={styles.error}>{errorMessage}</p>}
            </Flex>
            <TextLink to="/subscription/mypage">マイページに戻る</TextLink>
          </Flex>
        </Flex>
      </form>
    </Flex>
  )
}
